import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useMediaQuery } from '@mui/material';
import { Box } from '@mui/system';
import customToast from '../Components/Common/custom-toast.js';
import { getComparisionData } from '../Services/api-config.js';
import Loading from '../Components/Common/LoaderComponent/loader.js';
import EditHistoryModal from '../Components/Common/Modal/edit-history-modal.js';
import { getErrorMessage } from './util.js';
import RecipientListName from './recipient-list-name.js';
import './recipients-list.css';

const RecipientsList = ({
	displayedRecipients,
	showAll,
	toggleShowAll,
	initialDisplayCount = 2,
	totalRecipients = 0,
	showCompare = false,
	documentId = '',
	data
}) => {
	const isMobile = useMediaQuery('(max-width: 600px)');
	const {showToast} = customToast();
	const [isLoading, setIsLoading] = useState(false);
	const [historyOpen, setHistoryOpen] = useState(false);
	const [editHistory, setEditHistory] = useState([]);

	const fetchComparisionData = async () => {
		setIsLoading(true);
		try {
			const response = await getComparisionData(documentId);
			if (response?.status === 200) {
				const data = response.data?.recipientEditData || [];

				const formattedData = data;

				setEditHistory(formattedData);
				setHistoryOpen(true);
			} else {
				showToast('error', getErrorMessage(response));
			}
		} catch (error) {
			showToast('error', getErrorMessage(error));
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		if (showCompare) {
			fetchComparisionData();
		}
	}, [showCompare]);
	return (
		<div className='recipientsList'>
			<Loading open={isLoading}/>
			<EditHistoryModal
				open={historyOpen}
				onClose={() => setHistoryOpen(false)}
				recipientHistories={editHistory}
			/>

			<p>Recipients</p>
			<div className={'recipients'} style={{ paddingLeft: '2px', maxHeight: isMobile ? '200px' : '270px' }}>
				{displayedRecipients?.sort((a, b) => a?.recipientOrder - b?.recipientOrder)?.map((recipient) => (
					<div key={recipient.recipientId}>
						<div className='recipientsLoop'>
							<RecipientListName recipient={recipient} data={data}/>
						</div>
					</div>
				))}
			</div>
			{!showAll && totalRecipients > initialDisplayCount && (
				<Box onClick={toggleShowAll}>
					<p className='showAll'>Show More</p>
				</Box>
			)}
			{showAll && (
				<Box onClick={toggleShowAll}>
					<p className='showAll'>Show Less</p>
				</Box>
			)}
			{showCompare && <button
				style={{
					backgroundColor: '#B7D423',
					color: '#000',
					border: 'none',
					borderRadius: '4px',
					padding: '6px 12px',
					cursor: 'pointer',
					marginTop: '6px',
					fontSize: '14px',
					width: '100%',
					marginBottom: '22px'
				}}
				onClick={() => {
					fetchComparisionData();
				}}
			>
  View Edit History
			</button>
			}
		</div>
	);
};

export default RecipientsList;

RecipientsList.propTypes = {
	displayedRecipients: PropTypes.any,
	showAll: PropTypes.any,
	toggleShowAll: PropTypes.any,
	initialDisplayCount: PropTypes.any,
	totalRecipients: PropTypes.any,
	documentId: PropTypes.string,
	showCompare: PropTypes.bool
};
